module.exports = __webpack_public_path__ + "static/media/site.3642941d.webp";